import axiosInstance from "./AxiosConfig";

class RemarksApi {
  async CreateRemarks(data) {
    
    try {
      const response = await axiosInstance.post(`/remarks/create`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllRemarks() {
    try {
      const response = await axiosInstance.get(`/remarks/get`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetRemarksById(id) {
    try {
      const response = await axiosInstance.get(`/remarks/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async UpdateRemarksById(id, data) {
    try {
      const response = await axiosInstance.put(`/remarks/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteRemarksById(id) {
    try {
      const response = await axiosInstance.delete(`/remarks/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new RemarksApi();
